<template lang="pug">
  .bundle-and-save
    .md-fixed-width-tweak-upper.lg-fixed-width-tweak-upper
      .xs-12.md-7
        PdpCarousel(:images="prodImages")

      .bundle-info.xs-12.md-5
        .xs-fixed-width-tweak-upper.sm-fixed-width-tweak-upper
          .top-info.xs-12
            .price-wrap.xs-12
              p.upper.xs-f-small.lg-f-medium.max-at-tweak(v-if="!hasBundleProducts") {{ proProduct.name }}
              p.bundle-price.xs-f-small.lg-f-medium.max-at-tweak
                template(v-if="promoOfferAmount")
                  span(v-if="proProduct.value").strike.color-slate.xs-f-small.lg-f-medium.max-at-tweak {{ proProduct.price | currency }}&nbsp;
                  span.price.bold.xs-f-small.lg-f-medium.max-at-tweak(data-mr-ass="bundle-price") {{ proProduct.price - promoOfferAmount | currency }}
                  span.best-pill.upper.color-white.xs-f-xxsmall.max-at-tweak best value
                template(v-else)
                  span.price.bold.xs-f-small.lg-f-medium.max-at-tweak(data-mr-ass="bundle-price") {{ proProduct.price | currency }}

            template(v-if="hasBundleProducts")
              .info-title.xs-12.xs-text-center.lg-text-left
                p.bold.xs-f-small.lg-f-medium.max-at-tweak What's in your bundle?

              .info-wrap.xs-12
                .prod-info(v-for="prod in proProduct.bundleProducts" :key="prod.id")
                  p.upper.bold.xs-f-small.lg-f-medium.max-at-tweak(data-mr-ass="bundle-product-name") {{ prod.name }}
                  p.color-slate.xs-f-small.lg-f-medium.max-at-tweak {{ prod.desc.short }}

        .bottom-info.xs-12
          .xs-fixed-width-tweak-upper.sm-fixed-width-tweak-upper
            .info-added.xs-12.text-center(v-if="isInCart")
              p.xs-f-small.lg-f-medium.max-at-tweak Your item was added to bag
              template(v-if="seeMoreAddons" )
                button.btn-reset.next.arrow-link.xs-f-small.max-at-tweak(@click="goToProductsTab")
                  span.xs-f-small.max-at-tweak Next&nbsp;
                  span.icon-arrow-forward.xs-f-xlarge.max-at-tweak

              template(v-else)
                a.next.arrow-link.xs-f-small.max-at-tweak(aria-label="continue to bag" href="/cart" target="_self")
                  span.xs-f-small.max-at-tweak Next&nbsp;
                  span.icon-arrow-forward.xs-f-xlarge.max-at-tweak

            .info-ctas.xs-12.text-center(v-else)
              button.mr-btn.btn-block(type="button" :class='{ disabled: addingProduct }' @click="addProductToCart()" data-mr-ass="bundle-add-to-bag") Add to Bag
              template(v-if="seeMoreAddons")
                button.btn-reset.no-thanks.arrow-link.xs-f-small.max-at-tweak(@click="goToProductsTab" data-mr-ass="bundle-no-thanks")
                  span.xs-f-small.max-at-tweak No thanks&nbsp;
                  span.icon-arrow-forward.xs-f-xlarge.max-at-tweak

              template(v-else)
                a.no-thanks.arrow-link.xs-f-small.max-at-tweak(href="/cart" aria-label="continue to bag" target="_self")
                  span.xs-f-small.max-at-tweak(data-mr-ass="bundle-no-thanks") No thanks&nbsp;
                  span.icon-arrow-forward.xs-f-xlarge.max-at-tweak

</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex';
  import PdpCarousel from "../PdpCarousel";
  import vueCartSvc from "../../../services/vueCartSvc";

  export default {
    name: "BundleAndSave",
    
    components: {
      PdpCarousel
    },

    data() {
      return {
        bundlePromoId: 2878
      }
    },

    computed: {
      ...mapState('pdp', [
        'product'
      ]),

      ...mapState('xsell', [
        'proProduct'
      ]),

      ...mapState('cart', ['addingProduct']),
      ...mapGetters('cart', [
        'suggestedAddons',
        'productIdInCart'
      ]),

      isInCart() {
        return this.productIdInCart(this.proProduct.id);
      },

      seeMoreAddons() {
        return this.suggestedAddons.length > 0;
      },

      hasBundleProducts() {
        return this.proProduct.bundleProducts && this.proProduct.bundleProducts.length > 0;
      },

      promoOfferAmount() {
        if (this.bundlePromo && this.bundlePromo.offers && this.bundlePromo.offers[0] && this.bundlePromo.offers[0].amount) {
          return this.bundlePromo.offers[0].amount;
        }
        return 0;
      },

      prodImages() {
        let images;
        if (this.proProduct.imagery.pdpCarouselLarge) {
          images = this.proProduct.imagery.pdpCarouselLarge;
        } else {
          images = [ this.proProduct.imagery.standard ];
        }

        return images || [];
      }
    },

    asyncComputed: {
      bundlePromo() {
        return vueCartSvc.loadPromoById({ id: this.bundlePromoId }).then(res => res.data);
      }
    },

    methods: {
      ...mapActions('cart', [
        'addToCart',
        'loadCart'
      ]),

      addProductToCart() {
        if (this.addingProduct) {
          return;
        }


        vueCartSvc.applyPromo({
          promo: {
            id: this.bundlePromoId
          }
        }).then(() => {
          let payload = {
            productId: this.proProduct.id,
            ctaSource: 'Complete Routine Modal',
            cartType: 'active'
          };

          this.addToCart(payload).finally(() => {
            this.loadCart();
            this.goToProductsTab();
          });
        });
      },

      goToProductsTab() {
        this.$emit('show-tab', 'XsellProducts');
      }
    },

    mounted() {
      let trackPayload = {
        product_added_id: this.product.id,
        product_added_name: this.product.name,
        bundle_product_id: this.proProduct.id,
        bundle_product_name: this.proProduct.name
      };

      this.trackEvent('Complete the Routine Modal Bundle Viewed', trackPayload);
    }
  }
</script>

<style scoped lang="stylus">
  .bundle-and-save
    .bundle-info
      padding-right 1em
      padding-left 2em

      .price-wrap
        padding-bottom 1.5em
        border-bottom 1px solid #ccc

        .bundle-price
          span
            line-height 1.5em
            display inline-block
            vertical-align top

          .price
            margin-left 0.5em

          .best-pill
            background-color color-mr-blue
            border-radius 1em
            padding 0.25em 1em
            line-height 2em
            margin-left 2em

      .info-title
        padding 1.5em 0

      .info-wrap
        .prod-info
          position relative
          padding-left 2em
          padding-bottom 1.5em

          &:before
            content ''
            width 0.75em
            height 0.75em
            background-color color-mr-blue
            border-radius 50%
            position absolute
            top 0.25em
            left 0.25em

      .info-ctas
        .no-thanks
          padding 0.75em
          margin-top 0.5em

      .info-added
        background-color #f6f5f4
        padding 2em

    @media mq-mobile
      .bundle-wrap
        padding 0

        .bundle-info
          padding 0

          .top-info
            padding 0 5%

          .bottom-info
            background-color #f6f5f4

          .info-ctas
          .info-added
            padding 1.5em 5%

        .price-wrap
          padding 1.5em 5%

          .bundle-price
            .best-pill
              margin-left 5em

    @media mq-tablet
      .bundle-wrap
        padding 0

        .bundle-info
          padding 0

          .top-info
            padding 0 15%

          .bottom-info
            background-color #f6f5f4

          .info-ctas
          .info-added
            padding 1.5em 15%

        .price-wrap
          padding 1.5em 5%

          .bundle-price
            .best-pill
              margin-left 5em

</style>